// moz667: por culpa de vrdemo
var $ = jQuery;

/*
// TODO: No siempre tenemos vimeo... hay veces que hay otras cosas como youtube
// <div class="video-wrap">
//     <iframe class="streaming-video" src="{{ streaming.streaming_url }}" frameborder="0" allow="autoplay; fullscreen" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
// </div>
if (typeof Vimeo != "undefined" && Vimeo) {
    $(".wrap-streaming.streaming-video").each(function () {
        var $video_streaming = $(this);
        var $video_wrap = $video_streaming.find(".video-wrap");

        var player = new Vimeo.Player($video_wrap);

        player.play().then(function() {
            // Por ahora no hacemos nada aqui...
        }).catch(function(error) {
            console.log(error);
        });
    });
}
*/